import { useSelector } from 'react-redux'

import { getIsRegisteredForOnRamp } from 'store/user/selectors'
import SoldOutCTA from 'ui-component-library/components/OnrampCTA/SoldOutCTA'
import AlreadyRegisteredCTA from 'ui-component-library/components/OnrampCTA/AlreadyRegisteredCTA'
import PurchaseCTA from './PurchaseCTA'

type Props = {
  callToActionStatus: 'purchase'
  alreadyRegisteredCta: {
    bodyText: string
    headlineText: string
    alreadyRegisteredText: string
    alreadyRegisteredLinkUrl: string
    alreadyRegisteredLinkText: string
  }
  purchaseCta: {
    bodyText: string
    headlineText: string
    purchaseLinkText: string
    availabilityText: string
    valuePropText: string
    regionDropdown: {
      placeholderText: string
      options: { key: string; value: string }[]
    }
    product: {
      id: string
    }
  }
  soldOutCta: {
    bodyText: string
    headlineText: string
    availabilityText: string
  }
}

function OnrampCTA({
  callToActionStatus,
  purchaseCta,
  soldOutCta,
  alreadyRegisteredCta,
}: Props) {
  const isRegisteredForOnRamp = useSelector(getIsRegisteredForOnRamp)

  if (isRegisteredForOnRamp) {
    return <AlreadyRegisteredCTA {...alreadyRegisteredCta} />
  } else if (callToActionStatus === 'purchase') {
    return <PurchaseCTA {...purchaseCta} />
  } else {
    return <SoldOutCTA {...soldOutCta} />
  }
}

export default OnrampCTA
